import { StaffApi } from 'helpers';

class PdfService {
  authToken: string;
  pdfService: StaffApi;

  public constructor(authToken: string) {
    this.authToken = authToken;
    this.pdfService = new StaffApi('pdf', authToken);
  }
}

export default PdfService;

export const preparePdfForEditing = async (
  authToken: string,
  pdfBytes: Uint8Array,
  signal?: AbortSignal
): Promise<Uint8Array> => {
  const body = pdfBytes.buffer.slice(
    pdfBytes.byteOffset,
    pdfBytes.byteOffset + pdfBytes.byteLength
  );
  const { data } = await new PdfService(authToken).pdfService.post(
    'PreparePdfForEditing',
    body,
    {},
    { 'Content-Type': 'application/pdf' },
    signal,
    { responseType: 'arraybuffer' }
  );

  return new Uint8Array(data as ArrayBuffer);
};
